



















































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Livraison} from '@/models';

import CrudLivraisonFilter from '@/components/Crud/Livraison/Filter.vue';
import CrudLivraisonEditDialog from '@/components/Crud/Livraison/EditDialog.vue';
import CrudLivraisonList from '@/components/Crud/Livraison/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeLivraison, {LivraisonFilter} from '@/stores/modules/livraison';
import CrudLivraisonListLivraison from "@/components/Crud/Livraison/ListLivraison.vue";

@Component({
	components: {
		CrudLivraisonFilter,
		CrudLivraisonEditDialog,
		CrudLivraisonList,
		CrudLivraisonListLivraison,
		CrudDeleteDialog,
	}
})
export default class LivraisonListView extends Vue {

	@Stored(() => storeLivraison) private livraisons!: ResultType<Livraison>;
	@Stored(() => storeLivraison) private filters!: LivraisonFilter;

	private imgPath: string = "";

	private editLivraison: Livraison = null;
	private deletedLivraison: Livraison = null;
	private storeLivraison = storeLivraison;

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editLivraison = new Livraison();
		this.refresh();
	}

	private refresh(): void {
		storeLivraison.dispatch('getC', { filters: true });
	}
}
